// src/pages/shared/NoAccessPage.js
import React from 'react';
import { useTranslation } from 'react-i18next';

const NoAccessPage = () => {
  const { t } = useTranslation();
  return (
    <div style={{ textAlign: 'center', padding: '50px' }}>
      <h2>{t('noAccess')}</h2>
    </div>
  );
};

export default NoAccessPage;
